import { Routes } from '@angular/router';
import { App } from './app';
import { PrivacyPolicy } from './privacy-policy/privacy-policy';
import { PagamentoCompletato } from './pagamento-completato/pagamento-completato';
import { PagamentoFallito } from './pagamento-fallito/pagamento-fallito';
import { TerminiCondizioni } from './termini-condizioni/termini-condizioni';
import { Wizard } from './wizard/wizard';
import { Chat } from './chat/chat';

export const routes: Routes = [
  {
    path: '',
    component: App, // Non uso redirect altrimenti perdo i parametri
    children: [
      {
        path: 'privacy-policy',
        component: PrivacyPolicy,
        title: 'Privacy Policy'
      },
      {
        path: 'termini-condizioni',
        component: TerminiCondizioni,
        title: 'Termini e Condizioni'
      },
      {
        path: 'pagamento-completato',
        component: PagamentoCompletato,
        title: 'Pagamento Completato'
      },
      {
        path: 'pagamento-fallito',
        component: PagamentoFallito,
        title: 'Pagamento Fallito'
      },
      {
        path: 'chat',
        component: Chat,
        title: 'Assistente virtuale'
      },
      {
        path: 'step/:step',
        component: Wizard,
        title: 'Polizza Ritiro Patente Business'
      },
      { 
        path: '',
        component: Wizard,
        pathMatch: 'full',
        title: 'Polizza Ritiro Patente Business'
      },
      // 404
      // {
      //   path: '**',
      //   component: xxxxx
      // },
    ]
  },
];
